import { Component, inject } from '@angular/core';
import { VendorConstraintsPerRegionService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorConstraintsPerRegionCreateDto,
  VendorConstraintsPerRegionDto,
  VendorConstraintsPerRegionExcelDownloadDto,
  VendorConstraintsPerRegionUpdateDto,
} from 'orchestrator';
import { VENDORCONSTRAINTSPERREGION_CONFIG, VENDORCONSTRAINTSPERREGION_FIELDS } from './vendor-constraints-per-region.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor-constraints-per-region',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorConstraintsPerRegionService, ConfirmationService],
  templateUrl: './vendor-constraints-per-region.html',
  styleUrl: './vendor-constraints-per-region.scss',
})
export class VendorConstraintsPerRegion extends BaseHierarchicalCrudComponent<
  VendorConstraintsPerRegionDto,
  VendorConstraintsPerRegionCreateDto,
  VendorConstraintsPerRegionUpdateDto,
  VendorConstraintsPerRegionExcelDownloadDto
> {
  service = inject(VendorConstraintsPerRegionService);
  config = VENDORCONSTRAINTSPERREGION_CONFIG;
  fields = VENDORCONSTRAINTSPERREGION_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorConstraintsPerRegionDto): VendorConstraintsPerRegionUpdateDto {
    return {
      applyDose: data.applyDose,
      applyAps: data.applyAps,
      applySpecialCoefficient: data.applySpecialCoefficient,
      applyDosesApprovalInBioforest: data.applyDosesApprovalInBioforest,
      vendorId: data.vendorId,
      regionLocationId: data.regionLocationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorConstraintsPerRegion';
  }
}
